import React from 'react';
import Note from 'components/Note/Note'

// styles
import './CharCounter.scss'

const CharCounter = ({
  value = "",
  maxChars = 0,
  errorMessage = null
}) => {
  const getRemainingChars = (value, maxChars) => {
    let maxLimit = maxChars || 0
    let valueLength = value?.length || 0

    return maxLimit - valueLength
  }

  const getError = () => {
    let message = `${value?.length || 0}/${maxChars}`
    if (errorMessage) return `${message} ${errorMessage}`
    return message
  }

  let remainingChars = getRemainingChars(value, maxChars)

  return (
    <Note
      style={{ fontWeight: "normal" }}
      disabledIcon={true}
      type={remainingChars < 0 ? "error" : ""}
      text={`${remainingChars < 0 ? `${getError()}` : `${value?.length || 0}/${maxChars}`}`}
    />
  );
};

export default CharCounter;